<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { ReportBuilderViewModel } from "@Reports/Reports/Components/ReportBuilder";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class ReportBuilder extends Vue
    {
        get vm(): ReportBuilderViewModel { return this.$props.viewModel as ReportBuilderViewModel; }

        get opened() : boolean { return this.vm?.opened ?? false; }

        onFormSubmit()
        {
            this.$emit('create-report', this.vm.reportName);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Create report</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="report-builder-form" @submit.prevent="onFormSubmit">
                            <div class="form-group">
                                <label>Name:</label>
                                <input v-model.trim="vm.reportName" type="text" class="form-control" required minlength="2" maxlength="100">
                                <small class="text-danger">{{vm.reportNameError}}</small>
                            </div>
                        </form>
                    </div>

                    <div class="modal-footer justify-content-between">
                        <button type="submit" form="report-builder-form" class="btn btn-primary">Create</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>      


<style scoped>
</style>